import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Space, ExpandibleCardMobile, TextField, EditButton } from '~/components';
import { CheckThinIcon } from '~/img';
import { IndividualRowType } from './IndividualTable';

interface Props extends IndividualRowType {
  disableRowActions: boolean;
  hasBeneficialOwnersValidationWarnings: boolean;
}

const BeneficialOwnersCardMobile: FC<Props> = (props) => {
  const {
    firstName,
    lastName,
    shares,
    hasPassport,
    hasEmiratesId,
    // onDelete,
    onEdit,
    disableRowActions,
    hasBeneficialOwnersValidationWarnings,
  } = props;
  const { t } = useTranslation('fillApplication');

  return (
    <StyledTableCardMobile className="BeneficialOwnersCardMobile">
      <TextField label={t('First name')}>{firstName}</TextField>
      <TextField label={t('Last name')}>{lastName}</TextField>
      <TextField label={t('Shares %')}>{shares}</TextField>
      <TextField label={t('Passport')}>{hasPassport ? <CheckThinIcon /> : null}</TextField>
      <TextField label={t('Emirates ID')}>{hasEmiratesId ? <CheckThinIcon /> : null}</TextField>
      <div className="BeneficialOwnersCardMobile-ButtonsCol">
        <Space size={16} fullWidth={false}>
          {onEdit && (
            <EditButton
              className="BeneficialOwnersCardMobile-Button"
              id="beneficialOwnerTable_EditButton"
              disabled={disableRowActions}
              hasValidationWarnings={hasBeneficialOwnersValidationWarnings}
              onClick={onEdit}
            />
          )}
          {/* <DeleteButton
            className="BeneficialOwnersCardMobile-Button"
            id="beneficialOwnerTable_DeleteButton"
            disabled={disableRowActions}
            onClick={onDelete}
          /> */}
        </Space>
      </div>
    </StyledTableCardMobile>
  );
};

const StyledTableCardMobile = styled(ExpandibleCardMobile)`
  .BeneficialOwnersCardMobile-ButtonsCol {
    display: flex;
    align-items: center;
    height: 100%;
    .anticon {
      color: inherit;
    }
    .BeneficialOwnersCardMobile-Button {
      width: 32px;
      height: 32px;
      font-size: 16px;
    }
  }
`;

export default BeneficialOwnersCardMobile;
